// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

import ClientClass4 from './client4.js';

const Client4 = new ClientClass4();

export {
    Client4,
};
